import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, project, filter }) =>
    present(
      (project
        ? repository
            .getProjectResourcesListing(project, filter)
            .then(({ projectResources, totalPages }) => ({
              resources: projectResources.map(({ resource }) => resource),
              totalPages,
            }))
        : repository.getPlanzoneResourcesListing(filter)
      )
        .then(({ resources, totalPages }) => ({
          planzone,
          project,
          filter,
          resources,
          totalPages,
        }))
        .catch(() => Promise.reject({ planzone, project, filter })),
    );
}

export type { Interactor };

export { createInteractor };
